// components/SearchableDropdown.jsx (Multi-Select Version)
import React, { useState, useEffect, useCallback } from 'react';
import { TextField, Autocomplete, CircularProgress, Chip, Box } from '@mui/material';
import { debounce } from '@mui/material/utils';
import { toProperCase } from '../utils/formatRows';

const SearchableDropdown = ({ label, value = [], onChange, fetchOptions, valueKey = "UserId", labelKey = "EmployeeName", placeholder, error, helperText, required }) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const debouncedFetch = useCallback(
        debounce((searchTerm) => {
            setLoading(true);
            fetchOptions(searchTerm)
                .then((results) => {
                    if (open) setOptions(results || []);
                })
                .finally(() => setLoading(false));
        }, 400),
        [fetchOptions, open]
    );

    useEffect(() => {
        if (!open) {
            setOptions([]);
            return;
        }
        debouncedFetch(inputValue || "");
        return () => debouncedFetch.clear();
    }, [inputValue, open, debouncedFetch]);

    const handleDelete = (userToDelete) => {
        onChange(value.filter(u => u[valueKey] !== userToDelete[valueKey]));
    };

    console.log("options" , options)

    return (
        <Autocomplete multiple size="small" open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} value={value} onChange={(e, newValue) => onChange(newValue || [])} inputValue={inputValue} onInputChange={(e, newInputValue) => setInputValue(newInputValue || "")} options={toProperCase(options)} getOptionLabel={(option) => toProperCase(option[labelKey]) || ""} isOptionEqualToValue={(option, value) => option[valueKey] === value[valueKey]} loading={loading} noOptionsText="Type to search users..."
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                    <Chip key={option[valueKey]} label={option[labelKey]} size="small" onDelete={() => handleDelete(option)} color="primary" variant="outlined" sx={{ mr: 0.5 }} />
                ))
            }
            renderInput={(params) => (
                <TextField {...params} label={label} required={required} placeholder={value.length === 0 ? placeholder : ""} error={error} helperText={helperText}  sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                                }}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, pt: 0.5 }}> {params.InputProps.startAdornment} </Box>
                        ),
                        endAdornment: (
                            <>
                                {loading && <CircularProgress color="inherit" size={18} />}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default SearchableDropdown;